// Pure helpers for the Net Worth history panel — extracted so the
// benchmark-overlay data merge can be unit-tested without rendering.

export interface IndexedPoint { date: string; nw_indexed: number | null; bench_indexed: number | null }
export interface BenchmarkStat { window_pct: number; vs_net_worth_pct: number; indexed?: IndexedPoint[] }
export interface BenchmarkMap { spy?: BenchmarkStat; qqq?: BenchmarkStat }
export interface IndexedChartPoint { date: string; nw: number | null; spy: number | null; qqq: number | null }

/**
 * Merge the per-benchmark rebased `indexed` arrays into one date-keyed chart
 * dataset. nw_indexed is identical across benchmarks (it's the same net worth
 * rebased to the same base), so we take it from whichever series carries it.
 * Output is sorted ascending by date.
 */
export function mergeIndexedSeries(bm: BenchmarkMap): IndexedChartPoint[] {
  const byDate: Record<string, IndexedChartPoint> = {}
  const ingest = (pts: IndexedPoint[] | undefined, key: 'spy' | 'qqq') => {
    for (const p of pts ?? []) {
      const row = byDate[p.date] ?? { date: p.date, nw: null, spy: null, qqq: null }
      if (p.nw_indexed != null) row.nw = p.nw_indexed
      row[key] = p.bench_indexed
      byDate[p.date] = row
    }
  }
  ingest(bm.spy?.indexed, 'spy')
  ingest(bm.qqq?.indexed, 'qqq')
  return Object.values(byDate).sort((a, b) => a.date.localeCompare(b.date))
}
